// web-staking-estimator-frontend/src/EstimateResults.js
import React from "react";
import { Banner } from "./components/common";

export default function EstimateResults({
  estimate,
  requestInfo,
  estimateId,
  onGenerateEstimate,
  actionsDisabled = false,
  onStartServiceRequest,
  onStartOver,
  inlineError,      
  bannerMessage,
  bannerKind,
  startRequestDisabled = false,
  startOverDisabled = false,
}) {
  const disabled = !!actionsDisabled;

  const handleGenerate = (e) => {
    e?.preventDefault?.();
    if (disabled) return;
    onGenerateEstimate?.();
  };

  return (
    <div>
      {/* no title here; parent subcard owns the heading */}
      {inlineError && <div className="inline-error">{inlineError}</div>}
      <Banner message={bannerMessage} kind={bannerKind} />
      <div className="summary-actions" style={{ display: "flex", gap: 8, marginTop: 12 }}>
        <button
          className="btn btn-primary"
          onClick={handleGenerate}
          disabled={disabled}
          title={disabled ? "Complete the form first" : undefined}
        >
          Generate My Estimate
        </button>
        <button
          className="btn"
          onClick={onStartServiceRequest}
          disabled={startRequestDisabled}
          title={startRequestDisabled ? "Estimate not ready yet" : undefined}
        >
          Start Service Request
        </button>
        <button
          className="btn"
          onClick={onStartOver}
          disabled={startOverDisabled}
          title={startOverDisabled ? "Cannot start over while processing" : undefined}
          aria-label="Start over and clear current inputs"
        >
          Start Over
        </button>
      </div>
    </div>
  );
}
